var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.661 5.696h-.396l-.001-1.914C9.262 1.696 7.514-.002 5.367 0 3.22.002 1.472 1.699 1.474 3.785L1.477 5.7h-.141C.597 5.7-.002 6.283 0 7v5.701C0 13.418.6 14 1.339 14l8.325-.005c.739 0 1.338-.581 1.336-1.299V6.994c0-.717-.6-1.298-1.339-1.298zm-6.75.004L2.91 3.785c0-1.318 1.101-2.39 2.458-2.391 1.357 0 2.46 1.072 2.46 2.388l.003 1.914-4.918.004z",
    fill: "#6373A4",
    fillRule: "nonzero"
  })));
}

export default SvgLock;